import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button, { outline } from '@narvar/nth-button';
import s from '../exchangeSidebar.module.css';

export const mapStateToProps = ({
  language: {
    'returns.step_1.exchange_eligibility_only_header': exchangeOnlyMessage,
    'returns.step_1.sidepanel_inventory_empty': inventoryEmptyMessage,
    'returns.step_1.sidepanel_inventory_empty.exchange_only': inventoryEmptyExchangeOnlyMessage,
    'returns.step_1.sidepanel_back_button': backBtnMessage,
    'returns.step_1.sidepanel_returns_button': switchToReturnMessage,
  } = {},
}) => ({
  exchangeOnlyMessage,
  inventoryEmptyMessage,
  inventoryEmptyExchangeOnlyMessage,
  backBtnMessage,
  switchToReturnMessage,
});

const InventoryUnavailableMenu = ({
  exchangeOnlyMessage,
  inventoryEmptyMessage,
  inventoryEmptyExchangeOnlyMessage,
  backBtnMessage,
  switchToReturnMessage,
  returnEligibility,
  onClickDelete,
  onClickSwitchToReturn,
}) => (
  <div>
    {!returnEligibility && <div className={s.eligibility}> {exchangeOnlyMessage} </div>}
    <div className={s.error_message}>
      {returnEligibility ? inventoryEmptyMessage : inventoryEmptyExchangeOnlyMessage}
    </div>
    <Button
      className="narvar-btn-primary sidebar-dismiss-button sidebar-action-btn"
      s={{ marginTop: '1rem', ...outline() }}
      big
      onClick={onClickDelete}
    >
      {backBtnMessage}
    </Button>
    {returnEligibility && (
      <Button
        className="narvar-btn-secondary sidebar-return-trigger-button sidebar-action-btn"
        s={{ marginTop: '1rem', ...outline() }}
        big
        onClick={onClickSwitchToReturn}
      >
        {switchToReturnMessage}
      </Button>
    )}
  </div>
);

InventoryUnavailableMenu.propTypes = {
  exchangeOnlyMessage: PropTypes.string.isRequired,
  inventoryEmptyMessage: PropTypes.string.isRequired,
  inventoryEmptyExchangeOnlyMessage: PropTypes.string.isRequired,
  backBtnMessage: PropTypes.string.isRequired,
  switchToReturnMessage: PropTypes.string.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  onClickSwitchToReturn: PropTypes.func.isRequired,
  returnEligibility: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(InventoryUnavailableMenu);
